import { useContext } from "react";
import { ConfiguratorContext } from "../context";
import { QuoteComment, NewQuoteComment } from "../api/models"
import CommentCard, {EditCommentCard} from "./CommentCard";

const QuoteCommentCard = (props: {
  comment:QuoteComment
  onEdit: (id:number) => void
}) => {
  return <CommentCard {...props} />;
}

export const EditQuoteCommentCard = (props: {
  quoteId:string | undefined
  reset?:boolean
  comment?:QuoteComment | NewQuoteComment
  topicTags?: string[] | undefined
  onCancel:() => void
  onSave:(c:QuoteComment) => void
}) => {
  const configurator = useContext(ConfiguratorContext);
  return <EditCommentCard {...props}
                          updateApi={async (c) => {
                            if ( !props.quoteId ) return;

                            return await configurator.api.updateQuoteComment(props.quoteId, c);
                          }}
                          createApi={async (c) => {
                            if ( !props.quoteId ) return;

                            return await configurator.api.createQuoteComment(props.quoteId, c);
                          }}
  />;
}

export default QuoteCommentCard;

